export const clientsConstants = {
    GETALL_CLIENTS_REQUEST: 'GETALL_CLIENTS_REQUEST',
    GETALL_CLIENTS_SUCCESS: 'GETALL_CLIENTS_SUCCESS',
    GETALL_CLIENTS_FAILURE: 'GETALL_CLIENTS_FAILURE',
};
